/**
 * Alles wat we over deze bezoeker weten staat in localStorage. Er is geen
 * account: een `guestId` plus een voornaam is de hele identiteit, en het invite
 * token uit de QR-code is de enige toegangscontrole.
 *
 * Per slug opgeslagen, want iemand kan op één telefoon op twee feesten zijn.
 */

const prefix = 'confetti'

interface StoredGuest {
  guestId: string
  displayName: string
}

/**
 * localStorage kan gooien: privémodus in Safari, een volle quota, of een
 * browser waar de gebruiker opslag heeft uitgezet. Dat mag de app niet slopen
 * — dan werkt hij deze sessie zonder geheugen, en dat is beter dan een wit
 * scherm.
 */
function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Bewust stil: zie hierboven.
  }
}

function remove(key: string): void {
  try {
    window.localStorage.removeItem(key)
  } catch {
    // Bewust stil: zie hierboven.
  }
}

export function readGuest(slug: string): StoredGuest | null {
  const raw = read(`${prefix}.guest.${slug}`)

  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as Partial<StoredGuest>

    return parsed.guestId && parsed.displayName
      ? { guestId: parsed.guestId, displayName: parsed.displayName }
      : null
  } catch {
    return null
  }
}

export function writeGuest(slug: string, guest: StoredGuest): void {
  write(`${prefix}.guest.${slug}`, JSON.stringify(guest))
}

export function clearGuest(slug: string): void {
  remove(`${prefix}.guest.${slug}`)
}

/**
 * "Uitloggen" uit het menu. Het invite token gaat mee weg, anders sta je na
 * één tik weer binnen zonder dat de link opnieuw gescand is.
 */
export function clearSession(slug: string): void {
  remove(`${prefix}.guest.${slug}`)
  remove(`${prefix}.invite.${slug}`)
}
